import { useTranslation } from 'react-i18next'

import Button from '../../../Button'
import { QA_NAME_ADD_CHECKLIST_ITEM_BUTTON } from '../RequestProfileTabInternalTasks.constants'
import { useRequestProfileTabInternalTasksContext } from '../RequestProfileTabInternalTasks.hooks'
import { RequestProfileTabInternalTasksChecklistItemForm } from '../RequestProfileTabInternalTasksChecklistItemForm'

import * as styles from './RequestProfileTabInternalTasksChecklistAddItem.module.css'

import PlusIcon from '../../../../icons/plus.svg'

function RequestProfileTabInternalTasksChecklistAddItem({
  isAdding,
  isLoading,
  onCancel,
  onShow,
  onSubmit,
}) {
  const { t } = useTranslation()

  const { canEdit } = useRequestProfileTabInternalTasksContext()

  return canEdit ? (
    <div className={styles.RequestProfileTabInternalTasksChecklistAddItem}>
      {isAdding ? (
        <RequestProfileTabInternalTasksChecklistItemForm
          isLoading={isLoading}
          placeholder={t('RequestProfile.InternalTasksItemPlaceholderKey')}
          qaName={QA_NAME_ADD_CHECKLIST_ITEM_BUTTON}
          submitText={t('RequestProfile.InternalTasksAddTaskSubmitKey')}
          onCancel={onCancel}
          onSubmit={onSubmit}
        />
      ) : (
        <Button.Text
          beforeIconProps={{ Icon: PlusIcon }}
          qaName={QA_NAME_ADD_CHECKLIST_ITEM_BUTTON}
          text={t('RequestProfile.InternalTasksAddTaskKey')}
          onClick={onShow}
        />
      )}
    </div>
  ) : null
}

export default RequestProfileTabInternalTasksChecklistAddItem
